import { useQuery } from '@tanstack/react-query'

import { getVcnMigrationSummary } from '../../../api/vcn-management-api-client'

export const VCN_MIGRATION_SUMMARY_QUERY_KEY = 'vcn-migration-summary'

export function useVcnMigrationSummary() {
  return useQuery({
    queryKey: [VCN_MIGRATION_SUMMARY_QUERY_KEY],
    queryFn: getVcnMigrationSummary,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
